//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		name:'app',
		created:function(){
		    this.matchId = this.$route.query.matchId;
		  },
		data(){
			return{
				homeTeamId: '',
				visitTeamId: '',
				matchId: '',
				homeTeamScore:null,
				visitTeamScore:null,
				homeTeamPKScore:null,
				visitTeamPKScore:null,
				homeTeamName:'',
				visitTeamName:'',
				leagueName:'',
				location:'',
				startDate:'',
				homeTeamTotalScore:0,
				visitTeamTotalScore:0,
			}
		},
		mounted(){
			this.hagkHttp(this.hagkApi.getMatchInfoById(this.matchId), {})
			.then((res) => {
				this.homeTeamId = res.homeTeamId;
				this.homeTeamName = res.homeTeamName;
				this.visitTeamId = res.vistingTeamId;
				this.visitTeamName = res.vistingTeamName;
				this.leagueName = res.leagueName;
				this.location = res.location;
				this.startDate = res.time;
				if(this.startDate && this.startDate.length > 16)
					this.startDate = this.startDate.substring(0,16);

				if(res.result && res.result != null){
					if(res.result.goalFor != null){
						this.homeTeamScore = 0;
						this.homeTeamScore += res.result.goalFor;
					}
					if(res.result.homeExScore != null){
						this.homeTeamScore = this.homeTeamScore == null ? 0 : this.homeTeamScore;
						this.homeTeamScore += res.result.homeExScore;
					}
					if(res.result.homePkScore != null){
						this.homePkScore = 0;
						this.homeTeamPKScore += res.result.homePkScore;
					}
					if(res.result.goalAgainst != null){
						this.visitTeamScore = 0;
						this.visitTeamScore += res.result.goalAgainst;
					}
					if(res.result.visitorExScore != null){
						this.visitTeamScore = this.visitTeamScore == null ? 0 : this.visitTeamScore;
						this.visitTeamScore += res.result.visitorExScore;
					}
					if(res.result.visitorPkScore != null){
						this.visitorPkScore = 0;
						this.visitTeamPKScore += res.result.visitorPkScore;
					}
				}
				this.homeTeamTotalScore = (this.homeTeamScore == null ? 0 : this.homeTeamScore) + (this.homeTeamPKScore == null ? 0 : this.homeTeamPKScore);
				this.visitTeamTotalScore = (this.visitTeamScore == null ? 0 : this.visitTeamScore) + (this.visitTeamPKScore == null ? 0 : this.visitTeamPKScore);

				if(homeTeamScore == null && visitTeamScore == null && homeTeamPKScore == null && visitTeamPKScore == null){
					var realPath = window.location.href;
	        		var fullPath = realPath.substring(0,realPath.indexOf('/match_info'))+'/match_info_share?matchId='+this.matchId;
		            var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
		            var title = this.leagueName;
		            var desc = "主队："+this.homeTeamName+'\r\n客队：'+this.visitTeamName;
		            
		            wxShareConfig({
                            title: title,
                            desc: desc,
                            link: realPath,
                            imgUrl: shareImg,
                            type: 'link',
                            dataUrl: ''
                        }, () => {
                        }, () => {
                        },fullPath);
				}
				
			}, (error) => {
				console.log(error);
				window.alert('比赛信息获取失败！');
			})

		},
		methods:{
			dateFormate: function(time){
				var date = new Date();
				date.setTime(time);
			}
		}
	}



// WEBPACK FOOTER //
// ./src/components/MatchResultHeader.vue